import { createSelector } from "@reduxjs/toolkit";

import { UserSettings } from "../../model/user/settings/types/UserSettings";
import { RootState } from "../store";

const settingsState = (state: RootState) => state.settings;

const selectSettings = createSelector(
  settingsState,
  (state) => (state.settings || {}) as UserSettings,
);

export const settingsSliceSelectors = {
  selectSettings,
};
